import React, { useState } from 'react'
import waste from "../assets/images/waste.png";
import energy from "../assets/images/energy-saving.png";
import water from "../assets/images/save-water.png";
import plastic from "../assets/images/no-plastic.png";
import healthy from "../assets/images/yoga.png";
import food from "../assets/images/balanced-diet.png";
import ewaste from "../assets/images/renewable.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import sliderInner from '../assets/images/sliderInner.jpg';
import { Card, CardHeader, CardBody, CardFooter, CardTitle, Col } from "reactstrap";
import LineChart from "../Components/LineChart"


function Impact() {
  const [activeslider, setactiveslider] = useState(1)
  const [activeimagesec, setactiveimagesec] = useState(1)

  const dashboardNASDAQChart = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        data: [0, 19, 15, 20, 30, 40, 40, 50, 25, 30, 50, 70],
        fill: false,
        borderColor: "#fbc658",
        backgroundColor: "transparent",
        pointBorderColor: "#fbc658",
        pointRadius: 4,
        pointHoverRadius: 4,
        pointBorderWidth: 8,
        tension: 0.4,
      },
      {
        data: [0, 5, 10, 12, 20, 27, 30, 34, 42, 45, 55, 63],
        fill: false,
        borderColor: "#51CACF",
        backgroundColor: "transparent",
        pointBorderColor: "#51CACF",
        pointRadius: 4,
        pointHoverRadius: 4,
        pointBorderWidth: 8,
        tension: 0.4,
      },
    ],
    options: {
      plugins: {
        legend: { display: false },
      },
    },
  }

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: 'Chart.js Line Chart' },
    },
  };

  const labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const data = {
    labels,
    datasets: [
      {
        label: 'Dataset 1',
        data: [0, 19, 15, 20, 30, 40, 40, 50, 25, 30, 50, 70],
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
        label: 'Dataset 2',
        data: [0, 64, 5, 2, 15, 40, 40, 50, 25, 30, 50, 70],
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  };

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={sliderInner} alt="" />
        <div className="sliderInrHdng">
          <h2><span className="hdngBrkr">Impact</span></h2>
        </div>
      </section>
      <section className="sevenScopeSec">
        <div className="container-fluid">
          <div className="slider-container mt-5">
            <Slider {...settings}>
              <div className=''>
                <div className={activeslider === 1 ? "sliderbox active" : "sliderbox"} onClick={() => setactiveslider(1)}>
                  <div className="sliderboxicn">
                    <img src={waste} alt="" />
                  </div>
                  <div className="sliderboxcnt">Reduce Waste</div>
                </div>
              </div>
              <div>
                <div className={activeslider === 2 ? "sliderbox active" : "sliderbox"} onClick={() => setactiveslider(2)}>
                  <div className="sliderboxicn">
                    <img src={energy} alt="" />
                  </div>
                  <div className="sliderboxcnt">Save Energy</div>
                </div>
              </div>
              <div>
                <div className={activeslider === 3 ? "sliderbox active" : "sliderbox"} onClick={() => setactiveslider(3)}>
                  <div className="sliderboxicn">
                    <img src={water} alt="" />
                  </div>
                  <div className="sliderboxcnt">
                    Save Water
                  </div>
                </div>
              </div>
              <div>
                <div className={activeslider === 4 ? "sliderbox active" : "sliderbox"} onClick={() => setactiveslider(4)}>
                  <div className="sliderboxicn">
                    <img src={plastic} alt="" />
                  </div>
                  <div className="sliderboxcnt">
                    Say No to Single Use Plastic
                  </div>
                </div>
              </div>
              <div>
                <div className={activeslider === 5 ? "sliderbox active" : "sliderbox"} onClick={() => setactiveslider(5)}>
                  <div className="sliderboxicn">
                    <img src={healthy} alt="" />
                  </div>
                  <div className="sliderboxcnt">Adopt Healthy Lifestyles</div>
                </div>
              </div>
              <div>
                <div className={activeslider === 6 ? "sliderbox active" : "sliderbox"} onClick={() => setactiveslider(6)}>
                  <div className="sliderboxicn">
                    <img src={food} alt="" />
                  </div>
                  <div className="sliderboxcnt">Adopt Sustainable Food Systems</div>
                </div>
              </div>
              <div>
                <div className={activeslider === 7 ? "sliderbox active" : "sliderbox"} onClick={() => setactiveslider(7)}>
                  <div className="sliderboxicn">
                    <img src={ewaste} alt="" />
                  </div>
                  <div className="sliderboxcnt">Reduce E-Waste</div>
                </div>
              </div>
            </Slider>
          </div>

          {activeslider === 1 && (
            <div className='mt-5'>
              <div className="container">
                <div className="row impactDivTop">
                  <h3 className='my-3'>Save Energy</h3>

                  {activeimagesec === 1 && (
                    <div className="col-12 impactDiv">
                      <Col md="12">
                        <Card className="card-chart">
                          <CardHeader>
                            <CardTitle tag="h5">Mode of Implementation</CardTitle>
                            <p className="card-category">Line Chart with Points</p>
                          </CardHeader>
                          <CardBody>
                            <CardBody>
                              <LineChart />
                              {/* <Line options={options} data={data} /> */}
                            </CardBody>

                          </CardBody>
                          <CardFooter>
                            <div className="chart-legend">
                              <i className="fa fa-circle text-info" /> Digital {" "}
                              <i className="fa fa-circle text-warning" /> Physical
                            </div>
                            <hr />
                            <div className="card-stats">
                              <i className="fa fa-check" /> Data information certified
                            </div>
                          </CardFooter>
                        </Card>
                      </Col>
                    </div>
                  )}

                  {activeimagesec === 2 && (
                    <div className="col-12 activeslidercol-2">
                      <h3>Use Public transport wherever possible</h3>

                    </div>
                  )
                  }
                  {
                    activeimagesec === 3 && (
                      <div className="col-12 activeslidercol-2">
                        <h3>Take the stairs instead of an elevator wherever possible</h3>

                      </div>
                    )
                  }
                  {
                    activeimagesec === 4 && (
                      <div className="col-12 activeslidercol-2">
                        <h3>Switch off vehicles engines at red lights and railway crossings</h3>

                      </div>
                    )
                  }
                  {
                    activeimagesec === 5 && (
                      <div className="col-12 activeslidercol-2">
                        <h3>Use bicycles for local or short commute</h3>

                      </div>
                    )
                  }
                  {
                    activeimagesec === 6 && (
                      <div className="col-12 activeslidercol-2">
                        <h3>Switch off the irrigation pump after use</h3>

                      </div>
                    )
                  }

                </div>
              </div>
            </div>
          )
          }
          {
            activeslider === 2 && (
              <></>
            )
          }

        </div>
      </section>
    </>
  )
}

export default Impact